import React from 'react';
import {FormBlock, FormPost, FormBlockFieldCustomizeItem} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockFieldCustomizeItem;
}

interface Props {
  block: Block;
  post: FormPost;
}

export default ({block, post}: Props) => {
  const poolProspectCustomizeItem =
    block.formBlockable.poolProspectCustomizeItem;
  const label = poolProspectCustomizeItem.name;
  const value = post.formPostCustomizeItemSelects.find(
    (item) => item.formBlockFieldCustomizeItemId === block.formBlockable.id,
  )?.poolProspectCustomizeItemSelectOptions.map((item) => item.label).join(', ');

  return (
    <div className="w-full flex gap-4 items-center mb-3">
      <h4 className="text-c-light text-sm m-0 w-24">{label}</h4>
      <p className="m-0 text-base flex-1">{value}</p>
    </div>
  );
};
